<template>
  <e-link
    :class="b('', { variant, image: !!image })"
    :link="link"
  >
    <img
      v-if="image"
      :src="image"
      :alt="link.label || link.title || link.url"
      :class="b('image')"
    />
    <e-icon
      v-else
      :icon="iconName"
      :class="b('icon')"
      size="36"
    />
  </e-link>
</template>

<script lang="ts">
  import { PropType, defineComponent } from 'vue';
  import eIcon from '@/elements/e-icon.vue';
  import eLink from '@/elements/e-link.vue';
  import { Icon } from '@/types/icon';
  import { Link } from '@/types/link';

  // type Setup = {};
  // type Data = {};

  /**
   * Renders social media icons.
   */
  export default defineComponent({
    name: 'e-social-media-icon',
    components: {
      eLink,
      eIcon,
    },

    props: {
      /**
       * The url.
       */
      link: {
        type: Object as PropType<Partial<Link>>,
        required: true,
      },

      /**
       * Which type
       */
      type: {
        type: String,
        default: 'facebook',
        validator: (value: string) =>
          ['facebook', 'linkedin', 'pinterest', 'tik-tok', 'twitter', 'xing', 'youtube'].includes(value),
      },

      /**
       * Define an icon image.
       */
      image: {
        type: String,
        default: '',
      },

      /**
       * Which variant
       */
      variant: {
        type: String,
        default: 'default',
        validator: (value: string) => ['default', 'circle'].includes(value),
      },
    },
    // emits: [],

    // setup(): Setup {
    //   return {};
    // },
    // data(): Data {
    //   return {};
    // },

    computed: {
      iconName(): Icon {
        return `brand-${this.type}` as Icon;
      },
    },
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  });
</script>

<style lang="scss">
  @use '@/setup/scss/mixins';
  // @use '@/setup/scss/variables';

  .e-social-media-icon {
    &--variant-default {
      @include mixins.hover-effect--default;
    }

    &--variant-circle {
      @include mixins.hover-effect--default;

      background-color: var(--theme-color-grayscale--200);
      border-radius: 100%;
      padding: 0.5rem;
      color: var(--theme-color-grayscale--1000);
      aspect-ratio: 1;
    }

    &__image {
      width: 2.33rem;
      height: 2.33rem;
      max-width: none;
    }
  }
</style>
